module.exports = __webpack_public_path__ + "img/activities-1.40fe5ed6.jpg";